<template>

  <b-button class="px-4 h2 header-btn border-0 stand-up-animation animation-shadow rounded-pill">
    <slot></slot>
  </b-button>

</template>

<script>
export default {
  name: "Bt6",
}
</script>

<style scoped>

.stand-up-animation {
  transform: translateY(0px);
  transition: all 0.3s ease 0s;
}

.stand-up-animation:hover {

  color: #fff;
  transform: translateY(-7px);
  transition: all 0.3s ease 0s;
}

.animation-shadow:hover {
  box-shadow: 5px 5px 5px rgba(0, 0, 0, 0.25);
  transition: all 0.3s ease 0s;
}

.header-btn {
  background-color: var(--primary);
  color: var(--dark);
}

.header-btn:hover {
  background-color: var(--secondary);
  color: var(--light);

}
</style>